import React from 'react'

import generatePicker, { PickerProps } from 'antd/es/date-picker/generatePicker'
import { PickerComponentClass } from 'antd/es/date-picker/generatePicker/interface'
import moment from 'moment'
import type { Moment } from 'moment'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'

export type DatePickerProps = PickerComponentClass<PickerProps<Moment>>

const AntDatepicker = generatePicker<Moment>(momentGenerateConfig)

const DatePicker = (props: any) => {
  return <AntDatepicker className={`ant-input ${props.className}`} {...props} />
}

export default DatePicker
